export default __webpack_public_path__ + "static/media/bin.c8357c8b.svg";